import { Directive, HostListener, Output, EventEmitter } from '@angular/core';

@Directive({
  selector: '[appCapsLock]',
  standalone: true
})
export class CapsLockDirective {

  @Output() capsLockStatus = new EventEmitter<boolean>();

  @HostListener('keydown', ['$event'])
  @HostListener('keyup', ['$event'])
  detectCapsLock(event: KeyboardEvent) {
    const isCapsOn = event.getModifierState('CapsLock');
    this.capsLockStatus.emit(isCapsOn);
  }
}